import {Injectable} from '@angular/core';
import {PatternShift} from '@domain/calendar/pattern/pattern-shift';
import {NavigationHelperPrototypeService} from '@vdw/angular-component-library';
import {Observable} from 'rxjs';
import {AddPatternShiftDialogComponent} from './add-pattern-shift-dialog.component';
import {AddPatternShiftNavigationData} from './add-pattern-shift-navigation-data.interface';

@Injectable({providedIn: 'root'})
export class AddPatternShiftDialogService {
  public constructor(private readonly navigationHelper: NavigationHelperPrototypeService) {}

  public openContentSwitcherDialog(data: AddPatternShiftNavigationData): Observable<PatternShift[]> {
    return this.navigationHelper.navigateWithContentSwitcher<PatternShift[]>({
      componentInfo: {
        component: AddPatternShiftDialogComponent
      },
      data
    });
  }
}
